// RangeChart2.js
import React from 'react';
import { Column } from '@ant-design/plots';

const RangeChart2 = () => {
  // Define the data for the range chart with the new categories
  const data = [
    { category: 'Flaring', start: 0, end: 5000 },
    { category: 'Fuel Consumption', start: 5000, end: 10000 },
    { category: 'Fugitive', start: 10000, end: 15000 },
    { category: 'Venting', start: 15000, end: 20000 },
    { category: 'Unknown', start: 20000, end: 21000 },
    { category: 'Total', start: 0, end: 21000 },
  ];

  // Configuration for the range chart
  const config = {
    data,
    theme: "classicDark",
    height: 200,
    xField: 'category',
    yField: ['start', 'end'],
    colorField: (d) => (d.category === 'Total' ? 'Total' : 'Green'), // Use green for other categories
    tooltip: {
      items: ['start', 'end'],
    },
    meta: {
      category: {
        alias: 'Category',
      },
      start: {
        alias: 'Start Value',
      },
      end: {
        alias: 'End Value',
      },
    },
    color: ['Green', 'Blue'], // Define colors for the categories
    axis: {
      y: { labelFormatter: '~s' },
    },
  };

  return <Column {...config} />;
};

export default RangeChart2;
